<template>
  <vonap-window
    :modal="true"
    :visible="value"
    transition="dialog-scale-transition"
    title="Send mail"
    width="320px"
    height="217px"
    @close="close"
  >
    <v-layout row justify-center>
      <v-card>
        <v-container grid-list-xl text-xs-center style="height:132px;width:302px">
          <v-layout row wrap>
            <v-flex xs12 style="margin-top:-32px;height:65px">
              <vonap-toolbar-label>
                <v-switch v-model="testMode" label="Send TEST" />
              </vonap-toolbar-label>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-show="testMode"
                v-model="testEmail"
                type="email"
                label="Send To"
                required
                :rules="[v => !!v || 'Email is required!']"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <div class="spacer"></div>
          <v-btn block color="primary" @click="save" :disabled="sending">
            <v-progress-circular indeterminate v-if="sending" />
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </vonap-window>
</template>
<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import VonapWindow from '@/components/VonapWindow'
import VonapToolbarLabel from '@/components/VonapToolbarLabel'
import notification from '@/helpers/notification'

export default {
  name: 'DashboardBonCoupConfirmForm',
  components: {
    VonapWindow,
    VonapToolbarLabel,
  },
  props: {
    value: {type: Boolean},
    monthlyReportSendingId: {type: Number},
    asOfDate: {type: String, defaultValue: null},
    analystEmail: {type: String},
    responsibleEmail: {type: String},
  },
  mounted() {
    this.testEmail = this.currentUsername
  },
  data() {
    return {
      testMode: true,
      testEmail: '',
      sending: false,
    }
  },
  methods: {
    async save() {
      const data = {
        testMode: this.testMode,
        testEmail: this.testEmail,
        asOfDate: this.asOfDate,
        monthlyReportSendingId: this.monthlyReportSendingId,
        monthlyReportSendingListDetailId: -1,
        url: location.origin,
      }
      if (this.testMode) {
        await this.send(data)
      } else {
        data.testEmail = ''
        if (confirm('Are you sure you want to email the client?')) {
          await this.send(data)
        }
      }
    },
    async send(data) {
      this.sending = true
      let url
      if (data.monthlyReportSendingId === 0) {
        url = '/api/report/MonthlyReportSendingList/MultipleSendBonCoupMail'
        data = {
          asOfDate: data.asOfDate,
          analystEmail: this.analystEmail,
          responsibleEmail: this.responsibleEmail,
          testMode: data.testMode,
          testEmail: data.testEmail,
          url: data.url,
        }
      } else {
        url = '/api/report/MonthlyReportSendingList/SendBonCoupMail'
      }
      const response = await axios.post(url, data).catch(() => {
        notification('Some error', 'error')
        this.sending = false
      })

      if (response.status == 200) {
        this.$emit('success')
        if (response.data != 'Ok') {
          if (typeof response.data == 'string') {
            kendo.alert(response.data)
          } else if (response.data && response.data.message) {
            notification(response.data.message)
          }
        } else {
          notification('Report sent successfully')
        }
      }

      this.close()
    },
    close() {
      this.sending = false
      this.testMode = true
      this.testEmail = this.currentUsername
      this.$emit('input', false)
    },
  },
  computed: {
    ...mapGetters({currentUsername: 'authentication/currentUsername'}),
  },
}
</script>
